import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home.vue'
import Illustrations from '@/views/Illustrations.vue'
import Strips from '@/views/Strips.vue'
import Originals from '@/views/Originals.vue'
import Digital from '@/views/Digital.vue'
import Watercolor from '@/views/Watercolor.vue'
import Cards from '@/views/Cards.vue'
import Orders from '@/views/Orders.vue'
import About from '@/views/About.vue'
import Contact from '@/views/Contact.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'home',
  component: Home,
}, {
  path: '/illustration',
  name: 'illustrations',
  component: Illustrations,
}, {
  path: '/strips',
  name: 'strips',
  component: Strips,
}, {
  path: '/original',
  name: 'originals',
  component: Originals,
}, {
  path: '/watercolor',
  name: 'watercolor',
  component: Watercolor,
}, {
  path: '/digital',
  name: 'digital',
  component: Digital,
}, {
  path: '/cards',
  name: 'cards',
  component: Cards,
}, {
  path: '/orders',
  name: 'orders',
  component: Orders,
}, {
  path: '/about',
  name: 'about',
  component: About,
}, {
  path: '/contact',
  name: 'contact',
  component: Contact,
}]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If going back, we scroll to saved position
    if (savedPosition) {
      return savedPosition;
    }

    // If going to a specific hash, we scroll there
    if (to.hash) {
      return { selector: to.hash };
    }

    // Scrolling to the top of page otherwise
    return {x: 0, y: 0};
  },
})

export default router
